<template>
  <div class="pa-story-chapter-banner" @click.prevent="handleClick">
    <div class="meta">
      <div class="title">
        <p>物語管理番号</p>
        <p class="mini">-第-</p>
      </div>
      <p class="story-number">{{chapterData.chapter_number | mulateNumberZenkaku | mulateChapterNumberJP}}</p>
    </div>

    <div class="content">
      <p class="story-title" :class="titleAdditionalClass">{{chapterData.title}}</p>
    </div>
    
    <p class="readed-badge readed-badge-active" v-if="chapterData.readed">読了</p>
    <transition name="fade">
      <div class="overlay-wrapper" v-if="!chapterData.readable">
        <div class="overlay-content">
          <p>
            <span class="icon"><font-awesome-icon icon="lock" /></span>
            <span>施錠中</span>
          </p>
        </div>
        <div class="overlay"></div>
      </div>
    </transition>
  </div>
</template>

<script>
import _ from 'lodash';

export default {
  props : {
    chapterData : {
      default: null
    }
  },

  data(){
    return {
      titleAdditionalClass  : {
        'is-minify' : false,
        'is-middle' : false
      }
    };
  },

  watch : {
    chapterData : {
      handler(data){
        if(typeof data === 'undefined') return;
        
        if(data.title.length > 11){
          this.titleAdditionalClass['is-middle'] = true;
          this.titleAdditionalClass['is-minify'] = false;
        }
        
        if(data.title.length > 12){
          this.titleAdditionalClass['is-middle'] = false;
          this.titleAdditionalClass['is-minify'] = true;
        }
      },
      immediate: true,
      deep:true
    },
  },

  filters : {
    mulateChapterNumberJP(value){
      return _.padStart(value,6,'０');
    },

    mulateNumberZenkaku(value){
      value = value+'';

      return value.replace(/[A-Za-z0-9]/g, (str) => {
        return String.fromCharCode(str.charCodeAt(0) + 0xFEE0);
      });
    }
  },

  methods : {
    handleClick(){
      if(!this.chapterData.readable) return;

      this.$emit('selectChapter', this.chapterData);
    }
  }
}
</script>

<style lang="scss">
@import "~bulma/sass/utilities/_all";

.pa-story-chapter-banner{
  position: relative;
  box-sizing: border-box;
  margin:.5rem auto;
  border:3px solid #936f19;
  border-radius:4px;
  background-color: #c7a583;
  display: flex;
  flex-direction: row;

  @include from($desktop) {
    margin:12px auto;
  }
  
  div.meta{
    width:25%;

    div.title{
      background-color: #726047;
      color: #cbaf93;
      font-size:.7rem;
      text-align: center;
      margin:.2rem .2rem 0;
      padding:.1rem 0 .1rem 0;
      font-weight: normal;
      user-select: none;

      @include from($desktop) {
        font-size:1.1rem;
        margin:10px 10px 0;
        padding:8px 0;
      }

      @include until(375px) {
        font-size:.6rem;
      }

      .mini{
        margin-top:.1rem;
        font-size: .5rem;

        @include from($desktop) {
          margin-top:8px;
          font-size:.9rem;
        }
      }
    }
    
    p.story-number{
      color:#726047;
      font-weight: bold;
      font-size: .8rem;
      text-align: center;
      user-select: none;

      @include from($desktop) {
        font-size: 1rem;
      }

      @include until(375px) {
        font-size: .68rem;
      }
    }

    @include from($desktop) {
      width:35%;
    }
  }

  div.content{
    width:75%;
    margin-bottom:0;

    @include from($desktop) {
      width:65%;
    }
  }

  p.story-title{
    background-color: #c09f7e;
    border:2px solid #c9a784;
    color: #726047;
    font-size:1.4rem;
    text-align: center;
    min-height: 100%;
    padding-top:5px;
    overflow: hidden;
    user-select: none;

    @include until(375px) {
      font-size:1rem;
    }

    @include from($desktop) {
      display: flex;
      align-items: center;
      justify-content: center;
      font-size:1.8rem;
      border:6px solid #c9a784;
    }

    &.is-minify{
      font-size:1rem;
      padding-top:12px;

      @include from($desktop) {
        padding-top:5px;
        font-size:1.4rem;
      }

      @include until(375px) {
        font-size:.85rem;
      }
    }

    &.is-middle{
      font-size:1.2rem;
      padding-top:8px;

      @include until(375px) {
        font-size:1rem;
      }
    }
  }

  div.overlay-content{
    position: absolute;
    top:0;
    left:0;
    z-index: 102;
    color:#968577;
    text-align: center;
    letter-spacing:10px;
    width:100%;
    height: 100%;
    line-height: 100%;
    font-size: 1.5rem;
    padding-top:8px;
    background-color:rgba(153, 148, 143, .1);
    backdrop-filter: blur(3px);
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    
    p{
      user-select: none;
    }

    @include from($tablet) {
      p{
        margin-top:-1rem;
      }
    }

    transition: backdrop-filter 1s linear;

    span.icon{
      margin-right:.4rem;
    }
  }

  div.overlay{
    box-sizing:content-box;
    position: absolute;
    top:-3px;
    left:-3px;
    z-index: 101;
    background:red;
    width:100%;
    height:100%;
    background:radial-gradient(#4f4233 10%, #3a3026);
    border:3px solid #635240;
    border-radius: 3px;
    opacity: .8;
  }

  .readed-badge{
    position: absolute;
    top:0;
    right:0;
    margin-top:.2rem;
    margin-right:.4rem;
    font-size:.7rem;
    border-radius: 10px;
    width:40px;
    user-select: none;

    text-align: center;

    background-color:#a2a0a1;
    border:1px solid #b3b2b2;
    color:#bbb8ba;
    opacity:.8;

    &-active{
      background-color:#726047;
      border:1px solid #6c5d47;
      color:#cbaf93;
      opacity:.8;
    }

    @include from($desktop) {
      width:75px;
      font-size:1.1rem;
      margin-top:10px;
      margin-right:10px;
      border-radius: 20px;
    }
  }
}
</style>